import React, { FC, useMemo } from 'react';

import styles from './TermsAndConditions.module.css';
import { Page } from '../../../state/types';
import { config } from '../../../state/config';
import { useState } from '../../../state/store';
import { devices } from './devices';

const TermsAndConditions: FC = () => {
  const { page } = useState('page');

  const tradeInUrl = useMemo(() => {
    return <a href="https://tradein.macroev.com/samsung">https://tradein.macroev.com/samsung</a>;
  }, []);

  const gsmaUrl = useMemo(() => {
    return (
      <a href="https://www.gsma.com/services/tac/about-device-check/" target="_blank" rel="noreferrer">
        https://www.gsma.com/services/tac/about-device-check/
      </a>
    );
  }, []);

  const anpostUrl = useMemo(() => {
    return (
      <a href="https://forms.anpost.ie/enquiry" target="_blank" rel="noreferrer">
        https://forms.anpost.ie/enquiry
      </a>
    );
  }, []);

  const macroEvPrivacyLink = useMemo(() => {
    return (
      <a href="https://www.macroev.com/privacy-policy" target="_blank" rel="noreferrer">
        https://www.macroev.com/privacy-policy
      </a>
    );
  }, []);

  const postTradeInEmail = useMemo(() => {
    return <a href="mailto:online@macroev.com">online@macroev.com</a>;
  }, []);

  const samsungPrivacyLink = useMemo(() => {
    return (
      <a href="https://www.samsung.com/ie/info/privacy" target="_blank" rel="noreferrer">
        https://www.samsung.com/ie/info/privacy
      </a>
    );
  }, []);

  if (page !== Page.TermsAndConditions || config.tradeInSource !== 'samsung') {
    return null;
  }

  return (
    <div
      className={`${styles.TermsAndConditionsSamsung} container flex flex-col`}
      data-testid="TermsAndConditionsSamsungPage"
    >
      <section>
        <div>
          <h2 className="text-center">MACRO EVOLUTION SERVICES (MACROEV)</h2>
          <h2 className="text-center">TRADE-IN TERMS AND CONDITIONS</h2>
        </div>
      </section>
      <section className="text-justify mt-6">
        <h4>1. TERMS</h4>
        <p>
          These are the terms and conditions on which we take smartphone devices from you and on which you may take part
          in our Trade-In Programme. The trade-in programme provides you with the option to receive cash for your old
          smartphone device (‘Existing Smartphone’) subject to the Existing Smartphone’ being listed on our eligible
          Trade-In device list and conforms to our trade-in criteria which can be found at
          {tradeInUrl} and conforming to our “promotional terms and conditions” as laid out below and shown on our
          website {tradeInUrl}. This is also subject to you purchasing in store or online from either Eir, Virgin,
          Expert, DID, , Power City, Tesco Mobile Ireland, or Euronics (“Participating Retailer”) during the Promotion
          Period. This is subject to you purchasing either a new Samsung Galaxy Z Flip 5 , or Samsung Galaxy Z Fold 5.
          On proof of purchase you will be entitled to claim €100 per Samsung Galaxy Z Flip 5 , €150 per Samsung Galaxy
          Z Fold 5 within the “promotion period”. In addition, any Participant who trades in any existing Samsung Flip
          or Fold device from the list contained at
          {tradeInUrl} or as per Table 1 below shall be entitled to double the Reward which they would otherwise have
          been entitled to; for example a Participant who purchases a new Samsung Galaxy Z Flip 5 and trades in a
          previous Samsung Galaxy Z Flip device as per the eligible trade-in device list shall be entitled to claim
          €200, rather than €100, or a Participant who purchases a new Samsung Galaxy Z Fold 5 and trades in a previous
          Samsung Galaxy Z Flip device again as per the eligible trade-in device list shall be entitled to claim €300,
          rather than €150, by sending us your Existing Smartphone you agree to be bound by these terms and conditions.
        </p>
        <p>
          Please read these terms carefully if you would like to take part in the Trade-In Programme. These terms tell
          you who we are, the conditions of the Trade-In Programme and other important information.
        </p>
        <p>
          Please read these terms carefully before you send us your existing smartphone device(s) and take note of your
          existing smartphone IMEI number in case there is a problem with your order. Your existing smartphone IMEI
          number can be found by typing in *#06# in the smartphone phone dialler on your device (or in your device
          settings). It should also be printed on the back of your device or under the battery.
        </p>
        <p>
          IN ADDITION TO THESE TERMS AND CONDITIONS, THE FOLLOWING TERMS ALSO APPLY TO YOUR USE OF OUR WEBSITE AND DATA
          PROTECTION:
        </p>
        <p>{macroEvPrivacyLink}</p>
      </section>
      <section className="text-justify mt-6">
        <h4>2. INFORMATION ABOUT US AND HOW TO CONTACT US</h4>
        <p>
          2.1 Macro Evolution Services (MacroEV) is a white label Technical Service Company.
          Established in 2018 to provide a true end-to-end range of support to our partners. We provide technical and
          support service to enable partners to expand their value adding offerings to their clients without the need
          for expertise or infrastructure investment. Our technical support services facilities both in Ireland and the
          UK exceed global brand compliance standards. We also provide a range of technical support services to leading
          global vendors to improve their customer experience.
        </p>
        <p>
          You may contact us at any time via email at {postTradeInEmail} or see our contact info at the bottom of our
          website.
        </p>
        <p>
          2.2 If we have to contact you we will do so by telephone or by writing to you at the email address or postal
          address you provided to us in your order. Please note that ‘writing’ or ‘written’ includes emails.
        </p>
        <p>
          2.3 “Bonus Payment”: means €100 per Samsung Galaxy Z Flip 5 or €150 per Samsung Galaxy Z Fold 5 ordered
          between 26 July to 30 September 2023 to be paid to End Users by Samsung through MACROEV under these terms and
          conditions. Where the End User trades in an existing Samsung Flip or Fold device, the amount of this payment
          is doubled;
        </p>
        <p>
          2.4 “End Users”: means participants in the promotion who are eligible to participate in the Promotion and have
          sold a Trade In Device to MACROEV through the Promotion Website {tradeInUrl};
        </p>
      </section>
      <section className="text-justify mt-6">
        <h4>3. THE TRADE IN PROGRAMME – OVERVIEW/HOW TO TAKE PART</h4>
        <h5>3.1 Offer and Acceptance</h5>
        <p>
          This is subject to you purchasing in store or online from either Eir, , Virgin, Expert, DID, , Power City,
          Tesco Mobile Ireland, or Euronics (“Participating Retailer”) during the Promotion Period. This is subject to
          you purchasing either a new Samsung Galaxy Z Flip 5 , or Samsung Galaxy Z Fold 5 and within the ‘Key Promotion
          Dates’ (see below) of the promotional handset, you may, if you choose to do so by clicking on the relevant
          Trade-In option(s) on the {tradeInUrl} website be eligible to receive a cash value for your Existing
          Smartphone (subject to T&C’s). This is subject to also providing proof of purchase.
        </p>
        <h6>Key Promotion Dates</h6>
        <p>
          <strong>“Claim Period”</strong> starts at 9am (BST) on 4<sup>th</sup> August 2023 and ends at 23.59 (BST) on
          14<sup>th</sup> Oct 2023 closes at 23.59 (BST). The Promotion will commence at 00:01 (BST) on 26<sup>th</sup>{' '}
          July 2023 (BST) and shall close at 23.59 (BST) on 30<sup>th</sup> September 2023 (the “Promotion Period”).
          <br />
          Claims must be made by no later than 23.59 (BST) on 14<sup>th</sup> Oct 2023 (the “End Date”). Claims received
          after the End Date will be marked as invalid and will not be accepted.
          <br />
          MACROEV shall only pay out the Bonus Payments to End Users; who have claimed before the final end date 23.59
          (BST) on 14<sup>th</sup> Oct 2023 as set out in the Promotion Terms and Conditions herein
        </p>
        <p>
          Your completion of the online order form is an offer to us to purchase your Existing Smartphone. The contract
          between us and you is formed, subject to these terms and conditions, when we confirm receipt of your online
          order form. The contract between you and us (macroEV) is conditional upon us receiving your Existing
          Smartphone and it (and you) complying with these terms and conditions. The estimated price may vary as set out
          in these terms and conditions. 3.2 –
        </p>
        <h5>3.2 MACROEV shall only pay out the Bonus Payments to End Users: </h5>
        <p>
          3.2.1 who have claimed before the final end date 23.59 (BST) 14 October 2023 as set out in the Promotion Terms
          and Conditions;
        </p>
        <p>
          3.2.2 who have provided a unique IMEI or serial number for a Promotional Product which matches an IMEI or
          serial number provided by Samsung (and MACROEV shall not be responsible if such Samsung-provided IMEI or
          serial numbers are out of date or incorrect);{' '}
        </p>
        <p>
          3.2.3 who have entered the name of a Participating Retailer;
          <p>3.2.4 have entered a Purchase Date which is within the Promotion Period; </p>
          <p>3.2.5 have uploaded the IMEI or serial number of their Trade-In Device; and proof of purchase </p>
          <p>
            3.2.6 who sell a Trade-In Device to MACROEV, that meet the criteria as set out in the Promotion Terms and
            Conditions.
          </p>
          <h5>
            3.3 In determining whether the information provided by End Users is valid, MACROEV shall act in good faith
            and ensure its personnel exercise reasonable care, skill and judgment in such determination and, if it
            considers it necessary, request further information from the End User. In doing so MACROEV shall take the
            following minimum actions:{' '}
          </h5>
          <p>
            3.3.1 check against the IMEI or serial number provided by the End User to ensure it matches an IMEI or
            serial number provided by Samsung.{' '}
          </p>
          <p>
            3.3.2 record the IMEI or serial number provided by Samsung and compare future claims against recorded IMEI
            or serial numbers to ensure there is no duplication of claims.{' '}
          </p>
          <h5>
            3.4 MACROEV shall not otherwise be required to undertake any additional investigation or verification other
            than a review of the information provided.{' '}
          </h5>
          <h5>
            3.5 Should MACROEV be in doubt as to validity of any of the information provided by End Users, MACROEV shall
            contact Samsung who shall support MACROEV in authenticating the information (and MACROEV shall be entitled
            to rely upon and shall not be responsible for any decision, suggestion or information made or supplied by
            Samsung regarding authentication).
          </h5>
        </p>
        <p>To take part in the Trade-In Programme:</p>
        <ul>
          <li>You must be a consumer;</li>
          <li>
            You must meet at least the ‘<strong>Minimum Requirements</strong>’ as set out in section 3.2 below;
          </li>
          <li>You must complete the trade-in process as set out on our website {tradeInUrl};</li>
          <li>See {tradeInUrl} for further details.</li>
        </ul>

        <h5>3.2 Minimum Requirements</h5>
        <p>
          The Existing Smartphone must be owned by you; it must match the make and model you entered in our trade-in
          system, and it must also meet the following criteria.
        </p>
        <ul>
          <li>Be owned by the Participant making the Claim</li>
          <li>
            Participants who order a new (i.e. not second hand or ex-display) Samsung Galaxy Z Fold 5 or Samsung Galaxy
            Z Flip 5 as per the list in the table below, (“Promotion Products”) from either Eir, Virgin, Expert, DID, ,
            Power City, Tesco Mobile Ireland, or Euronics (“Participating Retailer”) during the Promotion Period. This
            is subject to you purchasing either a new Samsung Galaxy Z Flip 5 , or Samsung Galaxy Z Fold 5. On proof of
            purchase you will be entitled to claim €100 per Samsung Galaxy Z Flip 5 , €150 per Samsung Galaxy Z Fold 5
            within the “promotion period”. In addition, any Participant who trades in any existing Samsung Flip or Fold
            device from the list contained at {tradeInUrl} or as per Table 1 below shall be entitled to double the
            Reward which they would otherwise have been entitled to; for example a Participant who purchases a new
            Samsung Galaxy Z Flip 5 and trades in a previous Samsung Galaxy Z Flip device as per the eligible trade-in
            device list shall be entitled to claim €200, rather than €100, or a Participant who purchases a new Samsung
            Galaxy Z Fold 5 and trades in a previous Samsung Galaxy Z Flip device again as per the eligible trade-in
            device list shall be entitled to claim €300, rather than €150, by sending us your Existing Smartphone you
            agree to be bound by these terms and conditions.
          </li>
        </ul>
        <h5>Table 1: - Promotion Product (All colours / variants) SKU</h5>
        <ul>
          <li>Samsung Galaxy Z Fold 5 SM-F731B</li>
          <li>Samsung Galaxy Z Flip 5 SM-F946B</li>
        </ul>
        <h5>LIST OF TRADE IN DEVICES TO WHICH A DOUBLE REWARD IS PAYABLE</h5>
        <table className="table-auto border-collapse border border-slate-500 mb-3">
          <tbody>
            {devices.map((device, index) => (
              <tr key={`fold_${index}`}>
                <td className="border border-slate-500 px-2 py-1">{device}</td>
              </tr>
            ))}
          </tbody>
        </table>
        <p>
          For the purposes of clarity the following criteria below deems a smartphone to be in good working condition:
        </p>
        <ul>
          <li>It must power on/up and hold a charge</li>
          <li>It must be fully functional and must have no software or hardware faults</li>
          <li>
            It must only have normal wear and tear - there must be no damage or blemishes to screen/LCD and the casing
            around the device including the camera lens must not be cracked. No level of liquid damage is acceptable.
          </li>
          <li>
            It must have a fully functioning display and have no cracked screen, blobs, heavy screen burn, pink hue or
            pressure marks.
          </li>
          <li>It must not be blacklisted - each device must be eligible to pass all lost/stolen registers</li>
          <li>
            It must be factory reset and have no software locks - the device must have any personal account locks
            removed and the device must be reset to remove personal data, all devices must have their iCloud or Google
            accounts removed or custom MDM/UEM accounts removed.
          </li>
          <li>
            It must not be PIN locked and must not have an ‘Activation Lock’ or 'iCloud Lock' activated. (Please
            carefully review Clause 5.6 below)
          </li>
          <li>It must include its battery within the casing and must not have any missing parts</li>
          <li>It must not be crushed, bent in half or liquid-damaged</li>
          <li>
            It must not be “jail-broken, “rooted”, “bricked” or “Knox warranty void” and the firmware must not have been
            altered
          </li>
          <li>
            It must be original and meet the manufacturer’s original EU specifications (and is not personalised with any
            custom engraving). For example, the entire colour of the device must match the original manufacturer’s
            specification.
          </li>
          <li>Not have any other issues which affect our ability to resell it.</li>
        </ul>

        <p>
          For the purposes of clarity the following criteria below deems a smartphone to be in bad working condition:
        </p>
        <ul>
          <li>
            If the condition of the existing smartphone does not meet all of the ‘Good working condition’s’ criteria as
            listed above it will be deemed as a smartphone in ‘bad working condition’.
          </li>
        </ul>

        <p>
          3.3 We will assign an order number to your order and tell you what it is when we accept your order. It will
          help us if you can tell us the order number whenever you contact us about your order.
        </p>

        <h5>3.4 Acceptance</h5>
        <p>
          Following acceptance you will be provided/sent a prepaid return packaging/envelop to send your Existing
          Smartphone to us. You must package the Existing Smartphone in a manner such that it is suitably protected
          against any potential damage during postal return. Macro Evolution Services Ltd are not responsible for damage
          caused by inadequate packaging of the device. You should ensure that the Existing Smartphone is provided to us
          within 14 days of receiving your new Samsung Galaxy Z Flip 5 / Fold 5.
        </p>
        <p>
          3.5 PLEASE ENSURE THAT YOU BACK UP ANY PHOTOS, FILES AND OTHER DATA WHICH YOU HAVE STORED ON THE EXISTING
          SMARTPHONE AND REMOVE THE SIM CARD AND MEMORY CARDS BEFORE PROVIDING THE EXISTING SMARTPHONE TO US. ON RECEIPT
          OF THE EXISTING SMARTPHONE, ALL DATA STORED ON IT WILL BE SECURELY WIPED. WE ARE NOT ABLE TO RECOVER ANY DATA
          STORED ON AN EXISTING SMARTPHONE WHICH HAS BEEN PROVIDED TO US. WE CANNOT BE HELD RESPONSIBLE FOR YOUR
          PERSONAL DATA IF YOU HAVE NOT REMOVED IT FROM YOUR DEVICE OR IF YOUR DEVICE IS LOST IN TRANSIT WHEN BEING SENT
          TO OR RETURNED BY US.
        </p>
        <p>
          3.6 To the extent possible, we ask that you include the box and any original accessories which were included
          within the original box when you provide the Existing Smartphone to us. If no box is available, please ensure
          appropriate levels of protective packaging is applied for safe return.
        </p>
        <p>
          3.7 Please note that we inspect/evaluate under video all Existing Smartphones which are provided as part of
          the Trade-In Programme. If the Existing Smartphone which you are proposing to provide to us does not meet the
          terms that you had agreed during the trade-in process, then we, (Macro Evolution Services Ltd.) will contact
          you and notify you of this. If you have any concerns about the inspection of your Existing Smartphone, or wish
          to discuss the result of this inspection, please contact Macro Evolution Services @ {postTradeInEmail}.
        </p>
        <p>
          3.8 If you send us an Existing Smartphone which does not meet the initial trade-in terms that you had
          originally stated, or is not listed on our website, or if you do not comply with trade-in programme T&C’s as
          set out here-in or on our website {tradeInUrl}, If you send us an Existing Smartphone which does not meet the
          initial trade-in terms that you had originally stated, or is not listed on our website, or if you do not
          comply with trade-in programme T&C’s as set out here-in or on our website.
        </p>
        <p>
          3.9 You will not receive any payment for Existing Smartphone which are returned or recycled. In the event that
          you received any upfront payment/discount you will be liable to payback any monies or discounts provided to
          you during the trade-in process.
        </p>
        <p>
          3.10 Your device must not be blacklisted or reported lost or stolen. Please see the red flag procedure below.
        </p>
      </section>
      <section className="text-justify mt-6">
        <h4>4. GRADING YOUR DEVICE</h4>
        <p>
          If your trade-in quote form stated that your existing smartphone device was in good working condition, then to
          receive the full estimated price for your smartphone device, it must meet or exceed the “Good Working
          Condition” criteria as laid out earlier in section 3.2 Minimum Requirements.
        </p>
      </section>
      <section className="text-justify mt-6">
        <h4>5. PRICING</h4>
        <p>
          5.1 Prices displayed on our website include any applicable VAT and other tax, and are subject to change at any
          time without notice. Existing Smartphone prices are variable and if you check the value of your device but do
          not place a trade-in order, the value may be different at a later time.
        </p>
        <p>
          5.2 Any special offers on smartphone device prices are subject to particular terms which we may impose and may
          be varied or withdrawn at any time without notice. All prices are paid in EURO.
        </p>
        <p>
          5.3 The estimated price of any Existing Smartphone is guaranteed for 14 days from when you submit your
          trade-in online, subject to the smartphone device complying with these terms and conditions. We may remind you
          if we have not received your device within 14 days of your order.
        </p>
        <p>
          5.4 To be accepted, your Existing Smartphone must be received within 14 days following your request and comply
          fully with these terms and conditions.
        </p>
        <p>
          5.5 If your Existing Smartphone is received more than 14 days following your order or does not comply with
          these terms and conditions then reduced prices may apply or we may refuse to buy your device.
        </p>
        <p>
          5.6 If your Existing Smartphone still has the ‘Activation Lock’ or 'iCloud Lock' activated, we will contact
          you to ask for your help in unlocking it. If we do not receive a response within 5 days of us contacting you,
          your handset will be recycled and you will not receive any funds for this trade in. In the event that you
          received any upfront payment/discount you will be liable to payback any monies or discounts provided to you
          during the trade-in process.
        </p>
      </section>
      <section className="text-justify mt-6">
        <h4>6. REDUCED PRICES</h4>
        <p>
          6.1 If reduced prices apply, we will contact you to make a reduced offer. If you reject this offer we will
          return your Existing Smartphone. Reduced offers will be automatically processed for payment at the new reduced
          price if we do not receive your response to our proposed offer within 5 days.
        </p>
        <p>6.2 Our decision is final on all Existing Smartphone prices.</p>
      </section>
      <section className="text-justify mt-6">
        <h4>7. RED FLAGS</h4>
        <p>
          7.1 We check the status of all trade-in devices we receive against the National GSMA database {gsmaUrl} (using
          the unique IMEI or serial number).
        </p>
        <p>
          7.2 If your Existing Smartphone has a red flag (meaning it has been registered as lost, stolen, barred or
          blocked on the GSMA database), we must quarantine it for 28 days while its status is reviewed by you.
        </p>
        <p>
          7.3 If we notify you that your Existing Smartphone has a red flag you will need to contact the GSMA to have it
          removed, we will provide guidance on this procedure. If after 28 days you have been unable to get the device
          removed from the national GSMA device database we will have no option but to dispose of this device. Under no
          circumstances are we able to return a device to you if it is either registered or remains registered on the
          national GSMA database.
        </p>
        <p>
          7.4 If we become aware of any issues with your order you may be required to co-operate with the authorities
          and we reserve the right to withhold or cancel payment.
        </p>
        <p>
          7.5 If we become aware of a red flag or other ownership issue with your Existing Smartphone and we have
          already paid you for the Existing Smartphone, you agree to return that payment on our notification, and that
          we may take steps to recover that amount and any associated costs of recovery.
        </p>
      </section>
      <section className="text-justify mt-6">
        <h4>8. PAYMENTS AND OWNERSHIP</h4>
        <p>
          8.1 Ownership of you Existing Smartphone will pass to us when we dispatch payment to you or (if applicable)
          when we recycle it.
        </p>
        <p>
          8.2 Payments will be sent by the method chosen in your online order form. If you wish to amend your payment
          method, please contact us before payment is sent. Payment will only be sent following receipt, testing and
          acceptance of your existing smartphone device (or under the “Reduced Prices” process set out above).
        </p>
        <p>
          8.3 We issue trade-in payments normally within five working days unless there is an issue with your order. If
          there is an issue with your order we will attempt to contact you to notify you and inform you of the issue. If
          we do not receive a response you will be paid upon expiry of the 5 day notice period under the “Reduced
          Prices” process set out above. However, this is a timescale for guidance only and we cannot guarantee payment
          within that time.
        </p>
        <p>
          8.4 Payment processing depends on third parties (such as banks) whom we do not control, and on you inputting
          complete and accurate payment details during the online trade-in order process. We do not accept liability for
          any delay or failure in your receipt of payment as a result of those third parties’ action or inaction or your
          provision of inaccurate or incomplete details.
        </p>
      </section>
      <section className="text-justify mt-6">
        <h4>9. POSTAGE AND RETURNS</h4>
        <p>
          9.1 YOU MUST ENSURE THAT YOU ARE HAPPY TO SEND YOUR EXISTING SMARTPHONE TO US AND THAT IT IS WITHIN YOUR
          RIGHTS TO DO SO.
        </p>
        <p>
          9.2 You send your Existing Smartphone to us at your own risk. We cannot be responsible for devices we do not
          receive, or for the condition in which we receive devices. We strongly recommend that you pack your Existing
          Smartphone carefully to minimise the risk of damage. The sales pack does not guarantee that the device will be
          received in the same condition as sent.
        </p>
        <p>
          9.3 If we receive a damaged package, the package and device (if we received it) will be returned to you so
          that you may claim for the loss directly from An Post or courier used. By sending the package back to you we
          do not guarantee that the claim will be successful and we will not have any liability for any claims which are
          refused by external parties. If we have made any upfront payments or discounts on your Existing Smartphone you
          agree to return that payment on our notification, and that we may take steps to recover that amount and any
          associated costs of recovery.
        </p>
        <p>For more information about making claims with An Post, please visit {anpostUrl}.</p>
        <p>
          9.4 If we return your device, we use An Post at our cost (unless specified otherwise). If An Post cannot
          deliver the device, we will ask them to return it to our registered office and we will contact you to check
          your address. Once we receive confirmation that the address is correct we will resend the device.
        </p>
      </section>
      <section className="text-justify mt-6">
        <h4>10. LIABILITY</h4>
        <p>
          10.1 We will not be responsible for any loss or damage that is not foreseeable. Loss or damage is foreseeable
          if either it is obvious that it will happen or if, at the time the contract was made, both we and you knew it
          might happen, for example, if you discussed it with us during the sales process.
        </p>
        <p>
          10.2 Your statutory rights are not affected by these terms and conditions, and nothing in these terms and
          conditions limits our liability for death or personal injury caused by our negligence, our fraud or fraudulent
          misrepresentation or any other matter which cannot lawfully be limited or excluded.
        </p>
      </section>
      <section className="text-justify mt-6">
        <h4>11. FORMING THE CONTRACT</h4>
        <p>
          11.1 Your completion of the order form is an offer to us to purchase your Existing Smartphone. The contract
          between us and you is formed, subject to these terms and conditions, when we confirm receipt of your order
          form. The contract between you and us is conditional upon us receiving your Existing Smartphone and it (and
          you) complying with these terms and conditions. The estimated price may be varied as set out in these terms
          and conditions.
        </p>
        <p>
          11.2 Our contract with you will terminate or expire when we buy, recycle or return your Existing Smartphone in
          accordance with these terms and conditions.
        </p>
        <p>
          11.3 If a consumer, you may cancel your contract with us without charge at any point up until you send your
          Existing Smartphone to us. After this point you may not cancel your contract with us (but it may be terminated
          or expire as provided for in these terms and conditions).
        </p>
      </section>
      <section className="text-justify mt-6">
        <h4>12. EVENTS OUTSIDE OF OUR CONTROL</h4>
        <p>
          We will not be liable or responsible for any failure to perform, or delay in performance of, any of our
          obligations under our contact with you that is caused by events outside our reasonable control or due to our
          compliance with any applicable laws or regulations.
        </p>
      </section>
      <section className="text-justify mt-6">
        <h4>13. GENERAL</h4>
        <p>
          13.1 These terms and conditions are governed by Irish law and claims in relation to our contract with you are
          subject to the jurisdiction of the courts of the Republic of Ireland.
        </p>
        <p>
          13.2 If you need to contact us in relation to our contract with you, please use the methods set out in these
          terms and conditions. If we need to contact you, we may do so using any of the contact details you provided to
          us, including in your order form.
        </p>
      </section>
      <section className="text-justify mt-6">
        <h4>14. COMPLAINTS</h4>
        <p>
          If you have any complaints regarding our service, please contact us using the contact details provided at 2.1
          above or send an email to us at {postTradeInEmail}.
        </p>
      </section>
      <section className="text-justify mt-6 mb-10">
        <h4>15. HOW WE MAY USE YOUR PERSONAL INFORMATION</h4>
        <p>
          We will use your personal information in accordance with our Privacy Statement which can be found at{' '}
          {macroEvPrivacyLink}.
        </p>
      </section>

      <hr />

      <section className="mt-10">
        <div>
          <h2 className="text-center">SAMSUNG ELECTRONICS (UK) LIMITED</h2>
          <h2 className="text-center">Samsung Galaxy Z Flip 5, Z Fold 5 (“PROMOTION”)</h2>
          <h2 className="text-center">TERMS AND CONDITIONS</h2>
          <p className="text-justify mt-6">
            Participants agree to be bound by these terms and conditions (the “<strong>Terms and Conditions</strong>”).
            Any information or instructions published by the Promoter about the Promotion at {tradeInUrl} form part of
            the Terms and Conditions.
          </p>
        </div>
      </section>
      <section className="text-justify mt-6">
        <h4>The Promoter</h4>
        <p>
          1. The Promoter is Samsung Electronics (UK) Limited, Samsung House, 2000 Hillswood Drive, Chertsey, Surrey,
          KT16 0RS (the “<strong>Promoter</strong>”).
        </p>
      </section>
      <section className="text-justify mt-6">
        <h4>Promotion Period</h4>
        <p>
          2. The Promotion will commence at 00:01 on 26 July 2023 (GMT) and shall close at 23.59 (GMT) on 30 September
          2023 (the <strong>“Promotion Period”</strong>).
        </p>
      </section>
      <section className="text-justify mt-6">
        <h4>Eligibility</h4>
        <p>
          3. To be eligible to participate in the Promotion you must be an Ireland resident aged 18+ (or have obtained
          your parent or guardian’s consent to the relevant sale for the relevant sum) or a Company registered in
          Ireland (“<strong>Participant</strong>”).
        </p>
        <p>
          4. Employees or agents of the Promoter that are involved in the operation of this Promotion or anyone
          professionally connected to this Promotion are not eligible to enter.
        </p>
        <p>
          5. Network providers, retailers, distributors, resellers and any person who purchases the Promotion Product
          (defined below) for resale or otherwise not as the user of the Promotion Product, may not participate in this
          Promotion and are specifically excluded as a Participant.
        </p>
      </section>
      <section className="text-justify mt-6">
        <h4>Offer</h4>
        <p>
          Participants who order a new (i.e. not second hand or ex-display) Samsung Galaxy Z Flip 5 or Z Fold 5 from the
          list in the table below, (“Promotion Products”) in store or online from Eir, Virgin, Expert, DID, Power City,
          Tesco Mobile Ireland, or Euronics (“Participating Retailer”) during the Promotion Period and who trade in any
          smartphone listed at the following URL (operated by the company used by the Promoter to offer this promotion,
          Macro Evolution Services Limited (“MacroEV”)) from time to time: {tradeInUrl}/ which meets the requirements in
          term 9 below (“Trade In Device”) will be entitled to claim €100 per Samsung Galaxy Z Flip 5 , €150 per Samsung
          Galaxy Z Fold 5 paid by way of bank transfer) by redemption in addition to the payment made by MacroEV (each a
          “Reward”). In addition, any Participant who trades in any existing Samsung Flip or Fold device from the list
          below shall be entitled to double the Reward which they would otherwise have been entitled to; for example a
          Participant who purchases a new Samsung Galaxy Z Flip 5 and trades in a previous Samsung Galaxy Z Flip device
          shall be entitled to claim €200, rather than €100.
        </p>
        <h4>LIST OF PROMOTION PRODUCTS</h4>
        <table className="table-auto border-collapse border border-slate-500 mb-3">
          <thead>
            <tr>
              <th className="border border-slate-500 p-2">Promotional Product (All colours / variants)</th>
              <th className="border border-slate-500 p-2">SKU</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td className="border border-slate-500 px-2 py-1">Samsung Galaxy Z Fold 5</td>
              <td className="border border-slate-500 px-2 py-1">SM-F731B</td>
            </tr>
            <tr>
              <td className="border border-slate-500 px-2 py-1">Samsung Galaxy Z Flip 5</td>
              <td className="border border-slate-500 px-2 py-1">SM-F946B</td>
            </tr>
          </tbody>
        </table>
        <h4>LIST OF TRADE IN DEVICES TO WHICH A DOUBLE REWARD IS PAYABLE</h4>
        <table className="table-auto border-collapse border border-slate-500 mb-3">
          <tbody>
            {devices.map((device, index) => (
              <tr key={`fold_${index}`}>
                <td className="border border-slate-500 px-2 py-1">{device}</td>
              </tr>
            ))}
          </tbody>
        </table>
        <p>
          7. If a Participant’s Trade In Device can not be found at {tradeInUrl}/, Participants must contact MacroEV
          through that same URL, where the claim will be managed on a case-by-case basis.
        </p>
        <p>
          8. Purchases from auction websites (e.g. eBay) or from third party sellers on online retailers’ websites are
          specifically excluded from this Promotion.
        </p>
        <p>
          9. Any Trade In Device used to Claim in this Promotion must:
          <br />
          &nbsp;&nbsp;a. be owned by the Participant making the Claim;
          <br />
          &nbsp;&nbsp;b. includes its battery within the casing and not have any missing parts;
          <br />
          &nbsp;&nbsp;c. be complete and not crushed, bent in half or liquid-damaged;
          <br />
          &nbsp;&nbsp;d. not be PIN locked or have ‘Activation Lock’ or 'iCloud Lock' activated;
          <br />
          &nbsp;&nbsp;e. not be ‘jail-broken’ or similar and must not have altered firmware;
          <br />
          &nbsp;&nbsp;f. must meet the manufacturer’s original Ireland specifications; and
          <br />
          &nbsp;&nbsp;g. must not be personalised with any custom engraving.
          <br />
        </p>
        <p>
          10. Individual Participants may submit a maximum of one (1) Claim per Promotion Product purchased and a
          maximum of two (2) per household; and a maximum of ten (10) claims per Company Participant.
        </p>
        <p>
          11. Rewards are non-transferable. In the event of unforeseen circumstances, the Promoter may substitute a
          Reward of equal or greater value for the Reward.
        </p>
      </section>
      <section>
        <h4>Claims</h4>
        <p>
          To claim, Participants must first purchase a Promotion Product during the Promotion Period then visit the
          website below:
        </p>
        <p>
          <h5>Samsung Galaxy Z Flip 5 / Fold 5 Offer:</h5>
        </p>
        <p>{tradeInUrl}</p>
        <p>
          Participants must then enter the IMEI or serial number of the Promotion Product purchased and the IMEI or
          serial number of their Trade In Device, and complete the online claim form including the provision of bank
          account details (“Claim”).
        </p>
        <p>
          12. Claims must be made by 23:59 (BST) on 14 July 2023 (the “End Date”). Claims received after the End Date
          will be marked as invalid and will not be accepted.
        </p>
        <p>
          13. Participants will be sent an email confirming that their Claim has been received by the Promoter and will
          be sent a pre-paid special delivery envelope. Participants must post their Trade In Device in the envelope
          within fourteen (14) days of receipt.
        </p>
        <p>
          14. Company Participants must send their Trade in Devices to MacroEV using the address label provided within
          the confirmation email. Company Participants will be required to pay for postage of their Trade in Device.
        </p>
        <p>
          15. Within 48 hours of the Promoter receiving the Trade In envelope, the Promoter will validate proof of
          purchase with the Participating Retailer and then send an email to confirm whether the Claim has been
          successful and validated.
        </p>
        <p>16. Delivery of the Reward will be by bank transfer to the Ireland bank account provided in the Claim.</p>
        <p>
          17. Claims that are incomplete or damaged will be deemed invalid. No responsibility is accepted by the
          Promoter for lost, delayed or damaged data which occurs during any communication or transmission of Claims.
        </p>
        <p>
          18. The Promoter reserves the right at its absolute discretion to disqualify Claims which it considers do not
          comply with these Terms and Conditions.
        </p>
        <p>
          19. The Promoter shall have the right, where necessary, to undertake all such action as is reasonable to
          protect itself against fraudulent or invalid Claims including, without limitation, to require further
          verification as to proof of purchase, as well as the identity, age, and other relevant details of a
          Participant.
        </p>
      </section>
      <section>
        <h4>Privacy and Data Protection</h4>
        <p>
          20. Other than as set out in these Terms and Conditions or for the purposes of operating the Promotion, the
          details and information provided by the Participant when entering the Promotion or claiming the Reward will
          not be used for any promotional purpose, nor shall they be passed to any third party.
        </p>
        <p>21. The Participant acknowledges that the Promoter’s privacy policy is available at {samsungPrivacyLink}.</p>
      </section>
      <section>
        <h4>General</h4>
        <p>
          22. The Promoter shall not be liable for any interruption to the Promotion whether due to force majeure or
          other factors beyond the Promoter’s control.
        </p>
        <p>
          23. The Promoter reserves the right, acting reasonably and in accordance with all relevant legislation and
          codes of practice, to vary the Terms and Conditions of the Promotion.
        </p>
        <p>
          24. The Promoter will not be responsible or liable for: (a) any failure to receive submissions due to
          transmission failures and other conditions beyond its reasonable control; (b) any late, lost, misrouted, or
          damaged transmissions or Claim or Rewards; (c) any computer or communications related malfunctions or
          failures; (d) any disruptions, losses or damages caused by events beyond the control of the Promoter; or (e)
          any printing or typographical errors in any materials associated with the Promotion.
        </p>
        <p>
          25. Participants will be solely responsible for any and all applicable taxes and any other relevant costs or
          expenses which are not stated in the Terms and Conditions as being included.
        </p>
        <p>
          26. By participating in this Promotion Participants agree, to the maximum extent permitted by applicable laws,
          to release and hold the Promoter harmless from any and all liability whatsoever for any injuries, losses or
          damages of any kind arising from participation in or in connection with the Promotion, including without
          limitation, awarding, acceptance, receipt, possession, use and/or misuse of the Reward. The above limitation
          of liability shall not apply to liability arising from fraud (including fraudulent misrepresentation), death
          or personal injury caused as a result of Promoter’s negligence.
        </p>
        <p>27. The Promotion is governed by English law.</p>
      </section>
      <br />
      <br />
      <br />
    </div>
  );
};

export default TermsAndConditions;